import { useComponentClasses } from '@app/components/hooks';
import { Button, type ButtonProps } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

export default function ChapterTopNavigationButton({ children, ...buttonProps }: PropsWithChildren<ButtonProps>) {
    const { MuiButton: buttonClasses } = useComponentClasses('MuiButton');

    return (
        <Button
            variant="outlined"
            classes={{
                ...buttonClasses,
                root: twMerge(
                    buttonClasses.root,
                    'rounded-full p-0 w-[35px] h-[35px] min-w-0 max-w-[35px] dark:bg-transparent'
                ),
                disabled: twMerge(
                    buttonClasses.disabled,
                    '!bg-white dark:!bg-transparent border-[#e6e6e6] dark:border-white opacity-20'
                ),
            }}
            {...buttonProps}
        >
            {children}
        </Button>
    );
}
